import React from 'react';
import { Clock, User, ArrowRight } from 'lucide-react';
import { articlesData } from '../data/mock';

export const Articles = () => {
  return (
    <section id="artikel" className="py-20 px-4" style={{ background: 'var(--bg-section)' }}>
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Artikel & Wawasan Hukum</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Baca artikel terkini tentang perkembangan hukum dan regulasi di Indonesia
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {articlesData.map((article) => (
            <div key={article.id} className="voice-card hover-lift group cursor-pointer">
              {/* Article Image */}
              <div className="w-full h-48 rounded-lg overflow-hidden mb-4">
                <img 
                  src={article.image} 
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>

              {/* Category Badge */}
              <div className="inline-block px-3 py-1 rounded-full mb-3" 
                   style={{ background: 'var(--accent-blue-200)' }}>
                <span className="caption" style={{ color: 'var(--accent-blue-400)', fontWeight: 500 }}>
                  {article.category}
                </span>
              </div>

              {/* Title */}
              <h3 className="heading-3 mb-3 group-hover:text-opacity-80 transition-opacity">
                {article.title}
              </h3>

              {/* Excerpt */}
              <p className="body-small mb-4" style={{ color: 'var(--text-secondary)' }}>
                {article.excerpt}
              </p>

              {/* Meta Info */}
              <div className="flex items-center justify-between pt-4 border-t" 
                   style={{ borderColor: 'var(--border-light)' }}>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <User size={14} style={{ color: 'var(--text-muted)' }} />
                    <span className="caption" style={{ color: 'var(--text-muted)' }}>{article.author}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock size={14} style={{ color: 'var(--text-muted)' }} />
                    <span className="caption" style={{ color: 'var(--text-muted)' }}>{article.readTime}</span>
                  </div>
                </div>
                <ArrowRight 
                  size={18} 
                  style={{ color: 'var(--text-primary)' }}
                  className="transition-transform group-hover:translate-x-1"
                />
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <button className="btn-primary">
            Lihat Semua Artikel
          </button>
        </div>
      </div>
    </section>
  );
};
